import React, { useState, useEffect, useRef } from "react";
import { TextField, IconButton, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import {
  useFetchCreateMasterDepartmentsMutation,
  useFetchMasterDepartmentQuery,
  // useFetchMasterRoleQuery,
  // useFetchMasterSeverityStatusQuery,
} from "../../../slice/logdetailSlice";
import { deleteCommentEntities, postResource } from "../../../apis/apiService";
import Loader from "../../../components/common/Loader";
import { toast } from "react-toastify";

const Departmets = () => {
  // const { data, refetch, isLoading } = useFetchMasterSeverityStatusQuery();
  const [fields, setFields] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [showColorPicker, setShowColorPicker] = useState(null);
  const [statusType, setStatusType] = useState("");
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    field: null,
  });
  const colorPickerRef = useRef(null);
  //   const { data, refetch, isLoading } = useFetchMasterRoleQuery();
  const { data, refetch, isLoading } = useFetchMasterDepartmentQuery();
  //   const [createRoles] = useFetchCreateMasterRolesMutation();
  const [createRoles] = useFetchCreateMasterDepartmentsMutation();
  // console.log("master_data :", data);
  //   console.log("master_data  master_datas:", master_datas);
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (data) {
      //   const taskStatus = data.find((list) => list?.severity_type === "ISSUE");
      // //console.log()("task_severity_name Departmets: ", data);

      //   setStatusType(taskStatus?.severity_type);
      setFields(
        data.map((status) => ({
          id: status.department_id,
          department_name: status.department_name,
          isNew: false,
          isEditing: false,
        }))
      );
    }
  }, [data]);

  // API Update function
  const handleUpdate = async (updatedField) => {
    if (updatedField.isNew) return;

    try {
      const requestedData = {
        department_name: updatedField.department_name,
      };
      const response = await postResource("master/department", "update", updatedField.id, requestedData);
      toast.success(response.message);

      setFields((prevFields) =>
        prevFields.map((f) =>
          f.id === updatedField.id ? { ...f, isEditing: false } : f
        )
      );
    } 
    catch (err) {
      console.error("Error updating designation:", err.message);
      toast.error(err.message || err.response.data.message);
    }
  };

  // Edit text
  const handleEditLabel = (id, value) => {
    setFields((prevFields) =>
      prevFields.map((f) =>
        f.id === id ? { ...f, department_name: value } : f
      )
    );
  };

  // Add new field
  const handleAddField = () => {
    const newField = {
      id: Date.now(),
      department_name: "New Department",
      isNew: true,
    };
    setFields([...fields, newField]);
  };

  // Change color
  //

  // Save new field
  const handleSaveNewField = async (id) => {
    const savedField = fields.find((f) => f.id === id);
    if (!savedField) return;

    setFields((prevFields) =>
      prevFields.map((f) => (f.id === id ? { ...f, isNew: false } : f))
    );
    const requestedData = {
      department_name: savedField.department_name,
    };
    try {
      const response = await createRoles({
        url: "master/department/create",
        body: requestedData,
      });
      toast.success(response.message);
      refetch();
    } 
    catch (err) {
      console.error("Error saving new designation:", err.message);
      toast.error(err.message || err.response.data.message);
    }
  };

  // Enable editing on clicking edit button
  const handleEditClick = (id) => {
    setFields((prevFields) =>
      prevFields.map((f) => (f.id === id ? { ...f, isEditing: true } : f))
    );
  };

  // Save on blur (Update API only for existing fields)
  const handleBlur = (id) => {
    const updatedField = fields.find((f) => f.id === id);
    if (updatedField && !updatedField.isNew) {
      handleUpdate(updatedField);
    }
  };

  // Open delete confirmation popup
  const handleDeleteClick = (field) => {
    setDeleteDialog({ open: true, field });
  };

  // Delete API call
  const handleDelete = async () => {
    if (!deleteDialog.field) return;
    try {
      const response = await deleteCommentEntities("master/department/delete",deleteDialog.field.id);
      toast.success(response.message);
      setFields((prevFields) =>
        prevFields.filter((f) => f.id !== deleteDialog.field.id)
      );
    } 
    catch (err) {
      console.error("Error deleting designation:", err.message);
      toast.error(err.message || err.response.data.message);
    } 
    finally {
      setDeleteDialog({ open: false, field: null });
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target)
      ) {
        if (showColorPicker !== null) {
          const updatedField = fields.find((f) => f.id === showColorPicker);
          if (updatedField) {
            handleUpdate(updatedField); // Call API only after color picker closes
          }
        }
        setShowColorPicker(null);
      }
    }

    if (showColorPicker !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showColorPicker, fields]);
  // console.log("fields_list :", fields);

  return (
    <Box sx={{ display: "grid", gridColumn: 2 }}>
      {isLoading ? (
        <Loader />
      ) : (
        <Box p={3}>
          <h4>Departments</h4>
          <span className="line"></span>
          <p className=" text-secondary">
            Click the edit icon to edit the departments
          </p>
          <form>
            {fields.map((field) => (
              <Box key={field.id} display="flex" alignItems="center" mb={2}>
                <Box ml={1}>
                  <TextField
                    fullWidth
                    value={field.department_name}
                    onChange={(e) => handleEditLabel(field.id, e.target.value)}
                    onBlur={() => handleBlur(field.id)}
                    autoFocus={field.isNew || field.isEditing}
                    disabled={!field.isNew && !field.isEditing}
                  />
                </Box>

                {/* Buttons */}
                <Box display="flex" gap={1}>
                  {field.isNew ? (
                    <button
                      className=" mx-3 add_btn"
                      onClick={() => handleSaveNewField(field.id)}
                    >
                      save
                    </button>
                  ) : (
                    <>
                      <IconButton onClick={() => handleEditClick(field.id)}>
                        <Edit color="primary" />
                      </IconButton>
                      <IconButton onClick={() => handleDeleteClick(field)}>
                        <Delete color="error" />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Box>
            ))}
            <div className="d-flex gap-3 align-items-center">
              <button
                type="button"
                className="addmore_btn"
                onClick={handleAddField}
              >
                + Add Department
              </button>
            </div>
          </form>

          {/* Delete confirmation dialog */}
          <Dialog
            open={deleteDialog.open}
            onClose={() => setDeleteDialog({ open: false, field: null })}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <DialogContentText>
                  Are you sure you want to delete the Role "
                  {deleteDialog.field?.department_name}"?
                </DialogContentText>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setDeleteDialog({ open: false, field: null })}
              >
                No
              </Button>
              <Button onClick={handleDelete} color="error">
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </Box>
  );
};

export default Departmets;
